import { render } from "./ExtractionBigMenu.vue?vue&type=template&id=7edb9e38"
import script from "./ExtractionBigMenu.vue?vue&type=script&lang=js"
export * from "./ExtractionBigMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__